import { render, staticRenderFns } from "./auditHis.vue?vue&type=template&id=12c160b9&scoped=true"
import script from "./auditHis.vue?vue&type=script&lang=js"
export * from "./auditHis.vue?vue&type=script&lang=js"
import style0 from "./auditHis.vue?vue&type=style&index=0&id=12c160b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c160b9",
  null
  
)

export default component.exports